module.exports = __webpack_public_path__ + "static/img/pingtaizixun.e3eb96e8.png";